var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EmptyTrash, OpenConfirmDialog, } from '../../state/actions/commands';
import { DriveContextActions } from '../drive-context-actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
var noopTrue = function () { return true; };
var ɵ0 = noopTrue;
var TrashPageActions = /** @class */ (function (_super) {
    __extends(TrashPageActions, _super);
    function TrashPageActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actions = [
            {
                viewName: 'Empty Trash',
                icon: 'delete-forever',
                execute: function () {
                    _this.emptyTrash();
                },
                visible: noopTrue,
            },
        ];
        return _this;
    }
    TrashPageActions.prototype.emptyTrash = function () {
        this.store.dispatch(new OpenConfirmDialog({
            title: 'Empty Trash',
            body: 'All files and folders in your trash will be permanently deleted.',
            bodyBold: 'This action can not be undone.',
            ok: 'Empty Trash'
        }, new EmptyTrash()));
    };
    TrashPageActions.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TrashPageActions_Factory() { return new TrashPageActions(i0.ɵɵinject(i1.Store)); }, token: TrashPageActions, providedIn: "root" });
    return TrashPageActions;
}(DriveContextActions));
export { TrashPageActions };
export { ɵ0 };
